module.exports = __webpack_public_path__ + "img/MerryHead.3b8a0cd1.png";